<template>
    <div class="members">
        <h4 class="title is-6">Members</h4>

        <topic-members-form
            v-if="space_permission('TOPIC_MEMBER_CREATE', space)"
            @created="load"
            :topic="topic"
            :space="space"/>

        <base-loader v-if="list.loading"/>

        <div v-else class="members-list">
            <table class="table is-striped is-fullwidth">
                <tbody>
                    <topic-members-item
                        v-for="member in members"
                        :key="member.id"
                        :member="member"
                        :space="space"
                        :topic="topic"/>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import _uniqBy from 'lodash/uniqBy';
import TopicMembersItem from './TopicMembersItem.vue';
import TopicMembersForm from './TopicMembersForm.vue';

export default {
    props: ['space', 'topic'],
    components: { TopicMembersItem, TopicMembersForm },
    computed: {
        ...mapState('topic_members', ['list']),
        members() {
            return _uniqBy(this.list.data.results || [], 'user.id');
        },
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            this.$store.dispatch('topic_members/list', {
                space_id: this.space.id,
                topic_id: this.topic.id,
            });
        },
    },
};
</script>

<style scoped>
.members-list {
    max-height: 26rem;
    overflow: scroll;
}
</style>
